// eslint-disable-next-line import/prefer-default-export
import { formatDateToISO } from './formatDate'

export const INACTIVITY_DURATION = 60 * 600000
// export const INACTIVITY_DURATION = 30 * 60000
export const downloadTemplate = {
  batchLoanCreationCode: 2,
  batchCorporateCustomerAccountCode: 12,
  batchAccountCreationCode: 15,
  glCustomerUploadPostingCode: 16,
  batchDatingPostingCode: 18,
  batchIndividualCustomerCode: 19,
  assignedCardRequestCode: 22,
}

export const DUE_DILIGENCE_ENUMS = {
  LEGAL_AND_REGISTRATION_DOCUMENT: 'LegalAndRegistrationDocument',
  BOARD_AND_MANAGEMENT_INFORMATION: 'BoardAndManagementInformation',
  LEADERSHIP_AND_GOVERNANCE_STRUCTURE: 'LeadershipAndGovernanceStructure',
  FINANCIAL_STATEMENT: 'FinancialStatement',
  RECENT_FINANCIAL_PERFORMANCE: 'RecentFinancialPerformance',
  RISK_MANAGEMENT_FRAMEWORK: 'RiskManagementFramework',
  CREDIT_RISK_MANAGEMENT: 'CreditRiskManagement',
  LOAN_PORTFOLIO_DETAILS: 'LoanPortfolioDetails',
  AML_CFT_COMPLIANCE: 'AMLCFTCompliance',
  REGULATORY_COMPLIANCE: 'RegulatoryCompliance',
  REGULATORY_EXAMINATION_REPORTS: 'RegulatoryExaminationReports',
  RISK_AND_AUDIT_STRUCTURE: 'RiskAndAuditStructure',
  ONGOING_RISK_MONITORING: 'OngoingRiskMonitoring',
  INTERNAL_AUDIT_FINDINGS: 'InternalAuditFindings',
  CORPORATE_GOVERNANCE: 'CorporateGovernance',
  // COLLATERAL_MANAGEMENT: 'CollateralManagement',
  CREDIT_BUREAU_AGREEMENT: 'CreditBureauAgreement',
  CUSTOMER_COMPLAINTS_HANDLING: 'CustomerComplaintsHandling',
  CUSTOMER_CREDIT_PROGRAMS: 'CustomerCreditPrograms',
  CONSUMER_LOAN_PRICING: 'ConsumerLoanPricing',
  EXTERNAL_BOARD_ASSESSMENT: 'ExternalBoardAssessment',
  IT_SYSTEM_AGREEMENTS: 'ITSystemAgreements',
  TAX_AND_DEDUCTION_REMITTANCES: 'TaxAndDeductionRemittances',
  ENVIRONMENTAL_AND_SOCIAL_RISK: 'EnvironmentalAndSocialRisk',
  ADVANCED_RISK_ANALYSIS: 'AdvancedRiskAnalysis',
  RATING_AGENCY_REPORT: 'RatingAgencyReport',
  INTERNAL_RISK_MONITORING: 'InternalRiskMonitoring',
}

export const DUE_DILIGENCE_UPLOAD_TYPES = {
  CAC_REGISTRATION: 'cacRegistration',
  OPERATING_LICENSE: 'operatingLicense',
  ARTICLE_OF_ASSOCIATION: 'articleOfAssociation',
  CV_UPLOAD: 'cvUpload',
  CBN_APPROVAL_EVIDENCE: 'cbnApprovalEvidence',
  BANK_ORGANISATION_STRUCTURE: 'bankOrganisationStructure',
  BANK_ORGANISATION_CHART: 'bankOrganisationChart',
  AUDITED_FINANCIAL_STATEMENT_1: 'auditedFinancialStatement1',
  AUDITED_FINANCIAL_STATEMENT_2: 'auditedFinancialStatement2',
  AUDITED_FINANCIAL_STATEMENT_3: 'auditedFinancialStatement3',
  LASTEST_FINANCIAL_PERFORMANCE: 'latestFinancialPerformance',
  RISK_MANAGEMENT_FRAMEWORK: 'riskManagementFrameworkUrl',
  RISK_MANAGEMENT_POLICIES: 'riskManagementPoliciesUrl',
  RISK_MANAGEMENT_LIMITS: 'riskManagementLimitsUrl',
  RISK_MANAGEMENT_MANUAL: 'riskManagementManualUrl',
  CREDIT_PORTFOLIO_REPORT: 'creditPortfolioReport',
  CREDIT_RISK_MANAGEMENT: 'creditRiskManagement',
  ANTI_MONEY_LAUNDRY: 'antiMoneyLaundryUrl',
  COUNTER_TERRORIST_FINANCING: 'CounterTerroristFinancingPoliciesUrl',
  REGULATORY_RETURNS_RENDITION: 'RegulatoryReturnsRenditionUrl',
  CBN_EXAMINATION_REPORTS: 'CBNExaminationReportsUrl',
  NDIC_EXAMINATION_REPORTS: 'NDICExaminationReportUrl',
  MANAGEMENT_RESPONSE_TO_EXAMINATION_REPORTS: 'ManagementResponseToExaminationReportUrl',
  MANAGEMENT_RESPONSE_TO_NDIC_EXAMINATION_REPORTS: 'ManagementResponseToNDICExaminationReportsUrl',
  DEPARTMENT_STRUCTURE_ORGANOGRAM: 'OrganogramUrl',
  RISK_MANAGEMENT_UNIT_STAFF_DETAILS: 'documentUrl',
  INTERNAL_AUDIT_FUNCTION_STAFF_DETAILS: 'documentUrl_2',
  RISK_MANAGEMENT_REPORTS_BOARD: 'RiskManagementReportsToBoardUrl',
  INTERNAL_AUDIT_REPORTS_LAST_YEAR: 'InternalAuditsReportUrlLastYear',
  INTERNAL_AUDIT_REPORTS_LAST_TWO_YEARS: 'InternalAuditsReportUrlTwoYearsAgo',
  INTERNAL_AUDIT_REPORTS_LAST_THREE_YEARS: 'InternalAuditsReportUrlThreeYearsAgo',
  CORPRATE_GOVERNANCE_REPORT: 'CorporateGovernanceUrl',
  COLLATERAL_VALUATION: 'CollateralValuationUrl',
  NATIONAL_COLLATERAL_REGISTER: 'NationalCollateralRegistryUrl',
  EVIDENCE_OF_AGREEMENT: 'evidenceOfAgreement',
  CUSTOMER_COMPLAINTS_MANAGEMENT: 'customerComplaintsManagement',
  COPIES_CONSUMER_CREDIT: 'copiesConsumerCredit',
  LOAN_PRICING_STRATEGY: 'loanPricingStrategy',
  CONSUMER_LOAN_PRICING: 'consumerLoanPricing',
  RECENT_EXTERNAL_BOARD: 'recentExternalBoard',
  SIGNED_AGREEMENT: 'signedAgreement',
  EVIDENCE_OF_TAX: 'evidenceOfTax',
  EVIDENCE_OF_PENSION: 'evidenceOfPension',
  EVIDENCE_OF_OTHER_REMITTANCES: 'evidenceOfOtherRemittances',
  ENVIRONMENTAL_AND_SOCIAL_RISK: 'environmentalAndSocialRisk',
  RELEVANT_POLICIES_FRAMEWORK: 'RelevantPoliciesFramework',
  IMPLEMENTATION_EVIDENCE: 'ImplementationEvidence',
  RATING_AGENCY_REPORT: 'ratingAgencyReport',
  INTERNAL_RISK_MONITORING: 'InternalRiskMonitoring',

  STRESS_TEST_REPORTS: 'StressTestReports',
  MARKET_SENSITIVITY_ANALYSIS_REPORTS: 'MarketSensitivityAnalysisReports',
  LIQUIDITY_CONTINGENCY_FUNDING_PLAN: 'LiquidityContingencyFundingPlan',
  BUSINESS_CONTINUITY_AND_DISASTER_RECOVERY_PLAN: 'BusinessContinuityAndDisasterRecoveryPlan',

}

export const processingConfig = {
  legalDocumentList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.LEGAL_AND_REGISTRATION_DOCUMENT,
    fieldMap: { // Maps target property name to source value key
      evidenceOfCACRegistration: 'evidenceOfCACRegistrationURl',
      memorandum: 'memorandumAndArticleOfAssociationUrl',
      operatingLicense: 'operatingLicenceOFCBNUrl',
    },
  },
  leadershipAndGovernanceList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.LEADERSHIP_AND_GOVERNANCE_STRUCTURE,
    fieldMap: {
      bankOrganistionStructure: 'bankOrganizationStructureUrl',
      banksOrganisationalChart: 'banksOrganizationChart',
    },
  },
  financialStatementList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.FINANCIAL_STATEMENT,
    fieldMap: {
      auditedFinancialStatement1: 'auditedFinancialStatementLastYearUrl',
      auditedFinancialStatement2: 'auditedFinancialStatementTwoYearsAgoUrl',
      auditedFinancialStatement3: 'auditedFinancialStatementThreeYearsAgoUrl',
    },
  },
  recentFinancialPerformanceList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.RECENT_FINANCIAL_PERFORMANCE,
    fieldMap: {
      latestFinancialPerformance: 'latestQuarterlyManagementAccountsUrl',
      capitalAdequacyRatio: 'capitalAdequacyRatio',
      nonPerformingLoanRatio: 'nonPerformingLoanRatio',
      liquidityRatio: 'liquidityRatio',
      loanToDepositRatio: 'loanToDepositRatio',
    },
  },
  riskManagementFrameworkList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.RISK_MANAGEMENT_FRAMEWORK,
    fieldMap: {
      riskManagementFrameworkUrl: 'riskManagementFrameworkUrl',
      policiesUrl: 'policiesUrl',
      limitsUrl: 'limitsUrl',
      manualUrl: 'manualUrl',
    },
  },
  loanPortfolioDetailsList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.LOAN_PORTFOLIO_DETAILS,
    fieldMap: {
      creditPortfolioReport: 'creditPortfolioReport',
    },
  },
  aMLCFTComplianceList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.AML_CFT_COMPLIANCE,
    fieldMap: {
      antiMoneyLaundryUrl: 'antiMoneyLaundryUrl',
      counterTerroristFinancingPoliciesUrl: 'counterTerroristFinancingPoliciesUrl',
    },
  },
  regulatoryComplianceList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.REGULATORY_COMPLIANCE,
    fieldMap: {
      regulatoryReturnsRenditionUrl: 'regulatoryReturnsRenditionUrl',
    },
  },
  creditRiskManagementList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.CREDIT_RISK_MANAGEMENT,
    fieldMap: {
      creditRiskStrategyAndAnnualPortfolioPlan: 'creditRiskStrategyAndAnnualPortfolioPlanUrl',
    },
  },
  regulatoryExaminationReportsList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.REGULATORY_EXAMINATION_REPORTS,
    fieldMap: {
      cBNExaminationReportsUrl: 'cbnExaminationReportsUrl',
      nDICExaminationReportUrl: 'ndicExaminationReportUrl',
      managementResponseToExaminationReportUrl: 'managementResponseToExaminationReportUrl',
      managementResponseToNDICExaminationReportsUrl: 'managementResponseToNDICExaminationReportsUrl',
    },
  },
  riskAndAuditStructureList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.RISK_AND_AUDIT_STRUCTURE,
    fieldMap: {
      organogramUrl: 'organogramUrl',
      riskManagementUnitStaffDetails: 'riskManagementUnitStaffDetails',
      internalAuditFunctionStaffDetails: 'internalAuditFunctionStaffDetails',
    },
  },
  ongoingRiskMonitoringList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.ONGOING_RISK_MONITORING,
    fieldMap: {
      riskManagementReportsToBoardUrl: 'riskManagementReportsToBoardUrl',
    },
  },
  internalAuditFindingsList: { // Corrected name based on original variable
    sourceLabel: DUE_DILIGENCE_ENUMS.INTERNAL_AUDIT_FINDINGS,
    fieldMap: {
      internalAuditsReportUrlLastYear: 'internalAuditsReportUrlLastYear',
      internalAuditsReportUrlTwoYearsAgo: 'internalAuditsReportUrlTwoYearsAgo',
      internalAuditsReportUrlThreeYearsAgo: 'internalAuditsReportUrlThreeYearsAgo',
    },
  },
  corporateGovernanceList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.CORPORATE_GOVERNANCE,
    fieldMap: {
      corporateGovernanceUrl: 'corporateGovernanceUrl',
    },
  },
  collateralManagementList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.COLLATERAL_MANAGEMENT,
    fieldMap: {
      collateralValuationUrl: 'collateralValuationUrl',
      nationalCollateralRegistryUrl: 'nationalCollateralRegistryUrl',
    },
  },
  creditBureauList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.CREDIT_BUREAU_AGREEMENT,
    fieldMap: {
      evidenceOfAgreement: 'creditBureauAgreementUrl',
    },
  },
  customerComplaintHandlingList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.CUSTOMER_COMPLAINTS_HANDLING,
    fieldMap: {
      customerComplaintManagement: 'customerComplaintsHandlingUrl',
    },
  },
  consumerCreditList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.CUSTOMER_CREDIT_PROGRAMS,
    fieldMap: {
      copiesConsumerCredit: 'customerCreditProgramsUrls',
    },
  },
  consumerLoanPricingList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.CONSUMER_LOAN_PRICING,
    fieldMap: {
      loanPricingStrategy: 'consumerLoanPricingUrl',
    },
  },
  externalBoardAssessmentList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.EXTERNAL_BOARD_ASSESSMENT,
    fieldMap: {
      mostRecentExternalBoardEvaluation: 'externalBoardAssessmentUrl',
    },
  },
  taxDeductionList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.TAX_AND_DEDUCTION_REMITTANCES,
    fieldMap: {
      evidenceOfTaxRemittances: 'taxRemittanceUrl',
      evidenceOfPension: 'pensionNHFRemittanceUrl',
      evidenceOfOtherDeductions: 'otherDeductionRemittancesUrl',
    },
  },
  itSystemAgreementsList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.IT_SYSTEM_AGREEMENTS,
    fieldMap: {
      signedAgreement: 'itSystemAgreementsUrl',
    },
  },
  ratingAgencyReportsList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.RATING_AGENCY_REPORT,
    fieldMap: {
      ratingAgencyReport: 'ratingAgencyReportUrl',
    },
  },
  internalRiskMonitoringList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.RATING_AGENCY_REPORT,
    fieldMap: {
      riskRegisters: 'internalRiskMonitoringUrl',
    },
  },
  environmentAndSocialRiskList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.ENVIRONMENTAL_AND_SOCIAL_RISK,
    fieldMap: {
      environmentalAndSocialRiskManagementPolicies: 'environmentalAndSocialRiskManagementPoliciesUrl',
      relevantPoliciesFramework: 'relevantPoliciesFrameworkUrl',
      implementationEvidence: 'implementationEvidenceUrl',
    },
  },
  advancedRiskAnalysisList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.ADVANCED_RISK_ANALYSIS,
    fieldMap: {
      stressTestReports: 'stressTestReportsUrl',
      marketSensitivityAnalysisReports: 'marketSensitivityAnalysisReportsUrl',
      liquidityContingencyFundingPlan: 'liquidityContingencyFundingPlanUrl',
      businessContinuityAndDisasterRecoveryPlan: 'businessContinuityAndDisasterRecoveryPlanUrl',
    },
  },
  // Special case for Board and Management
  boardManagementList: {
    sourceLabel: DUE_DILIGENCE_ENUMS.BOARD_AND_MANAGEMENT_INFORMATION,
    collectionPath: 'board', // Path to the array within sourceItem.value
    collectionFieldMap: { // Maps target property name to source item (within collection) key
      designation: 'designation',
      // fullName: 'name',
      lastName: 'lastName',
      firstName: 'firstName',
      middleName: 'middleName',
      cvUpload: 'resumeURl',
      cbnApprovalEvidence: 'cbnApprovalUrl',
      dateAppointed: 'dateAppointed',
    },
  },
}

export const saveConfig = {
  saveLegalRegDocuments: {
    label: DUE_DILIGENCE_ENUMS.LEGAL_AND_REGISTRATION_DOCUMENT,
    // Map source fields to expected payload keys (assuming lowercase + Url suffix)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      evidenceOfCACRegistrationURl: sourceDoc.legalRegDocuments?.cacRegistration,
      memorandumAndArticleOfAssociationUrl: sourceDoc.legalRegDocuments?.articleOfAssociation,
      operatingLicenceOFCBNUrl: sourceDoc.legalRegDocuments?.operatingLicense,
      comment: sourceDoc.legalRegDocuments?.comment,
    }),
    listProperty: 'legalDocumentList',
    processingConfigKey: 'legalDocumentList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.legalRegDocuments', // Path in dueDiligence object
    resetValue: {
      cacRegistration: [], articleOfAssociation: [], operatingLicense: [], comment: '',
    },
    validationRef: 'legalDocumentsRules',
    successMessageKey: 'Your request to save Legal Registration Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Legal Document?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Legal Governance Structure
  saveLegalGovernance: {
    label: DUE_DILIGENCE_ENUMS.LEADERSHIP_AND_GOVERNANCE_STRUCTURE,
    // Map source fields to expected payload keys (assuming lowercase 'Organization')
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      bankOrganizationStructureUrl: sourceDoc.leadershipGovernance?.bankOrganisationStructure, // Corrected casing, mapped 'Organisation' to 'Organization'
      banksOrganizationChart: sourceDoc.leadershipGovernance?.bankOrganisationChart, // Corrected casing, mapped 'Organisation' to 'Organization'
      comment: sourceDoc.leadershipGovernance?.comment,
    }),
    listProperty: 'leadershipAndGovernanceList',
    processingConfigKey: 'leadershipAndGovernanceList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.leadershipGovernance',
    resetValue: { bankOrganisationStructure: [], bankOrganisationChart: [], comment: '' },
    validationRef: 'leadershipStructureRules',
    // Corrected success message
    successMessageKey: 'Your request to save Leadership Governance Structure was successful',
    confirmMessage: 'Are you sure you want to Save this Legal Governance?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Financial Statements
  saveFinancialStatements: {
    label: DUE_DILIGENCE_ENUMS.FINANCIAL_STATEMENT,
    // Map source fields to expected payload keys (assuming lowercase + YearUrl)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      auditedFinancialStatementThreeYearsAgoUrl: sourceDoc.financialStatements?.auditedFinancialStatement3,
      auditedFinancialStatementTwoYearsAgoUrl: sourceDoc.financialStatements?.auditedFinancialStatement2,
      auditedFinancialStatementLastYearUrl: sourceDoc.financialStatements?.auditedFinancialStatement1,
      comment: sourceDoc.financialStatements?.comment,
    }),
    listProperty: 'financialStatementList',
    processingConfigKey: 'financialStatementList', // Key in the processingConfig object
    // Corrected reset path
    resetPath: 'compulsoryDocument.financialStatements',
    resetValue: {
      auditedFinancialStatement1: [], auditedFinancialStatement2: [], auditedFinancialStatement3: [], comment: '',
    },
    validationRef: 'financialStatementRules',
    successMessageKey: 'Your request to save Financial Statement Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Financial Statements?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Recent Financial Performance
  saveRecentFinancialPerformance: {
    label: DUE_DILIGENCE_ENUMS.RECENT_FINANCIAL_PERFORMANCE,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      latestQuarterlyManagementAccountsUrl: sourceDoc.recentFinancialPerformance?.latestFinancialPerformance,
      capitalAdequacyRatio: sourceDoc.recentFinancialPerformance?.capitalAdequacyRatio,
      nonPerformingLoanRatio: sourceDoc.recentFinancialPerformance?.nonPerformingLoanRatio,
      liquidityRatio: sourceDoc.recentFinancialPerformance?.liquidityRatio,
      loanToDepositRatio: sourceDoc.recentFinancialPerformance?.loanToDepositRatio,
      comment: sourceDoc.recentFinancialPerformance?.comment,
    }),
    // Corrected list property
    listProperty: 'recentFinancialPerformanceList',
    processingConfigKey: 'recentFinancialPerformanceList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.recentFinancialPerformance',
    resetValue: {
      latestFinancialPerformance: [], capitalAdequacyRatio: '', nonPerformingLoanRatio: '', liquidityRatio: '', loanToDepositRatio: '', comment: '',
    },
    validationRef: 'recentFinancialPerformanceRules',
    successMessageKey: 'Your request to save Recent Financial Performance Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Recent Financial Performance ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Risk Management Framework
  saveRiskManagementFramework: {
    label: DUE_DILIGENCE_ENUMS.RISK_MANAGEMENT_FRAMEWORK,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      riskManagementFrameworkUrl: sourceDoc.riskManagementFramework?.riskManagementFrameworkUrl,
      policiesUrl: sourceDoc.riskManagementFramework?.policiesUrl,
      limitsUrl: sourceDoc.riskManagementFramework?.limitsUrl,
      manualUrl: sourceDoc.riskManagementFramework?.manualUrl,
      comment: sourceDoc.riskManagementFramework?.comment,
    }),
    listProperty: 'riskManagementFrameworkList',
    processingConfigKey: 'riskManagementFrameworkList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.riskManagementFramework',
    resetValue: {
      riskManagementFrameworkUrl: [], policiesUrl: [], limitsUrl: [], manualUrl: [], comment: '',
    },
    validationRef: 'riskManagementFrameworkRules',
    successMessageKey: 'Your request to save Risk Management Framework Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Risk Management Framework?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Loan Portfolio Details
  saveLoanPortfolioDetails: {
    label: DUE_DILIGENCE_ENUMS.LOAN_PORTFOLIO_DETAILS,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      creditPortfolioReport: sourceDoc.loanPortfolioDetails?.creditPortfolioReport,
      comment: sourceDoc.loanPortfolioDetails?.comment,
    }),
    listProperty: 'loanPortfolioDetailsList',
    processingConfigKey: 'loanPortfolioDetailsList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.loanPortfolioDetails',
    resetValue: { creditPortfolioReport: [], comment: '' },
    validationRef: 'loanPortfolioDetailsRules',
    successMessageKey: 'Your request to save Credit Portfolio Report Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Credit Portfolio Report?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Loan Portfolio Details
  saveCreditRiskManagement: {
    label: DUE_DILIGENCE_ENUMS.CREDIT_RISK_MANAGEMENT,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      creditRiskStrategyAndAnnualPortfolioPlanUrl: sourceDoc.creditRiskManagement?.creditRiskStrategyAndAnnualPortfolioPlan,
      comment: sourceDoc.creditRiskManagement?.comment,
    }),
    listProperty: 'creditRiskManagementList',
    processingConfigKey: 'creditRiskManagementList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.creditRiskManagement',
    resetValue: { creditRiskStrategyAndAnnualPortfolioPlan: [], comment: '' },
    validationRef: 'creditRiskManagementRules',
    successMessageKey: 'Your request to save Credit Risk Management and Annual Portfolio Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Credit Risk Management and Annual Portfolio?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving AML/CFT Compliance
  saveAMLCFTCompliance: {
    label: DUE_DILIGENCE_ENUMS.AML_CFT_COMPLIANCE,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      antiMoneyLaundryUrl: sourceDoc.aMLCFTCompliance?.antiMoneyLaundryUrl,
      counterTerroristFinancingPoliciesUrl: sourceDoc.aMLCFTCompliance?.counterTerroristFinancingPoliciesUrl,
      comment: sourceDoc.aMLCFTCompliance?.comment,
    }),
    listProperty: 'aMLCFTComplianceList',
    processingConfigKey: 'aMLCFTComplianceList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.aMLCFTCompliance',
    resetValue: { antiMoneyLaundryUrl: [], counterTerroristFinancingPoliciesUrl: [], comment: '' },
    validationRef: 'AML_CFTComplianceRules', // Assuming this ref name is correct
    successMessageKey: 'Your request to save Anti-Money Laundering/Counter Terrorist Financing Compliance Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Anti-Money Laundering/Counter Terrorist Financing Compliance ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Risk And Audit Structure
  saveRiskAndAuditStructure: {
    label: DUE_DILIGENCE_ENUMS.RISK_AND_AUDIT_STRUCTURE,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      organogramUrl: sourceDoc.riskAndAuditStructure?.organogramUrl,
      riskManagementUnitStaffDetails: sourceDoc.riskAndAuditStructure?.riskManagementUnitStaffDetails,
      internalAuditFunctionStaffDetails: sourceDoc.riskAndAuditStructure?.internalAuditFunctionStaffDetails,
      comment: sourceDoc.riskAndAuditStructure?.comment,
    }),
    // Corrected list property
    listProperty: 'riskAndAuditStructureList',
    processingConfigKey: 'riskAndAuditStructureList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.riskAndAuditStructure',
    // Corrected reset value to match source structure (string for staff details)
    resetValue: {
      organogramUrl: [], riskManagementUnitStaffDetails: '', internalAuditFunctionStaffDetails: '', comment: '',
    },
    validationRef: 'riskAndAuditStructureRules',
    successMessageKey: 'Your request to save Risk And Audit Structure Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Risk And Audit Structure ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Ongoing Risk Monitoring
  saveOngoingRiskMonitoring: {
    label: DUE_DILIGENCE_ENUMS.ONGOING_RISK_MONITORING,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      riskManagementReportsToBoardUrl: sourceDoc.ongoingRiskMonitoring?.riskManagementReportsToBoardUrl,
      comment: sourceDoc.ongoingRiskMonitoring?.comment,
    }),
    listProperty: 'ongoingRiskMonitoringList',
    processingConfigKey: 'ongoingRiskMonitoringList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.ongoingRiskMonitoring',
    resetValue: { riskManagementReportsToBoardUrl: [], comment: '' },
    validationRef: 'ongoingRiskMonitoringRules',
    successMessageKey: 'Your request to save Ongoing Risk Monitoring Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Ongoing Risk Monitoring ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Internal Audit Findings
  saveInternalAuditFindings: {
    label: DUE_DILIGENCE_ENUMS.INTERNAL_AUDIT_FINDINGS,
    // Map source fields to expected payload keys (matching source keys)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      internalAuditsReportUrlLastYear: sourceDoc.internalAuditFindings?.internalAuditsReportUrlLastYear,
      internalAuditsReportUrlTwoYearsAgo: sourceDoc.internalAuditFindings?.internalAuditsReportUrlTwoYearsAgo,
      internalAuditsReportUrlThreeYearsAgo: sourceDoc.internalAuditFindings?.internalAuditsReportUrlThreeYearsAgo,
      comment: sourceDoc.internalAuditFindings?.comment,
    }),
    listProperty: 'internalAuditFindingsList',
    processingConfigKey: 'internalAuditFindingsList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.internalAuditFindings',
    resetValue: {
      internalAuditsReportUrlLastYear: [], internalAuditsReportUrlTwoYearsAgo: [], internalAuditsReportUrlThreeYearsAgo: [], comment: '',
    },
    validationRef: 'internalAuditFindingsRules',
    successMessageKey: 'Your request to save Internal Audit Findings Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Internal Audit Findings ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Corporate Governance
  saveCorporateGovernance: {
    label: DUE_DILIGENCE_ENUMS.CORPORATE_GOVERNANCE,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      corporateGovernanceUrl: sourceDoc.corporateGovernance?.corporateGovernanceUrl,
      comment: sourceDoc.corporateGovernance?.comment,
    }),
    listProperty: 'corporateGovernanceList',
    processingConfigKey: 'corporateGovernanceList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.corporateGovernance',
    resetValue: { corporateGovernanceUrl: [], comment: '' },
    validationRef: 'corporateGovernanceRules',
    successMessageKey: 'Your request to save Corporate Governance Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Corporate Governance ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Collateral Management
  saveCollateralManagement: {
    label: DUE_DILIGENCE_ENUMS.COLLATERAL_MANAGEMENT,
    // Map source fields to expected payload keys (assuming lowercase)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      collateralValuationUrl: sourceDoc.collateralManagement?.collateralValuationUrl,
      nationalCollateralRegistryUrl: sourceDoc.collateralManagement?.nationalCollateralRegistryUrl,
      comment: sourceDoc.collateralManagement?.comment,
    }),
    listProperty: 'collateralManagementList',
    processingConfigKey: 'collateralManagementList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.collateralManagement',
    resetValue: { collateralValuationUrl: [], nationalCollateralRegistryUrl: [], comment: '' },
    validationRef: 'collateralManagementRules',
    successMessageKey: 'Your request to save Collateral Management Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Collateral Management ?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Credit Bureau Agreement
  saveCreditBureau: {
    label: DUE_DILIGENCE_ENUMS.CREDIT_BUREAU_AGREEMENT,
    // Map source fields to expected payload keys (assuming lowercase + Url)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      creditBureauAgreementUrl: sourceDoc.creditBureauAgreement?.evidenceOfAgreement, // Map evidenceOfAgreement to creditBureauAgreementUrl
      comment: sourceDoc.creditBureauAgreement?.comment,
    }),
    listProperty: 'creditBureauList',
    processingConfigKey: 'creditBureauList', // Key in the processingConfig object
    resetPath: 'compulsoryDocument.creditBureauAgreement',
    resetValue: { evidenceOfAgreement: [], comment: '' },
    validationRef: 'creditBureauAgreementRules',
    successMessageKey: 'Your request to save Credit Bureau Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Credit Bureau Agreement?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Customer Complaints Handling
  saveCustomerComplaintsHandling: {
    label: DUE_DILIGENCE_ENUMS.CUSTOMER_COMPLAINTS_HANDLING,
    // Map source fields to expected payload keys (assuming lowercase + Url)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.supportingDocument
      customerComplaintsHandlingUrl: sourceDoc.customerComplaintsHandling?.customerComplaintsManagement, // Map customerComplaintsManagement to customerComplaintsHandlingUrl
      comment: sourceDoc.customerComplaintsHandling?.comment,
    }),
    listProperty: 'customerComplaintHandlingList',
    processingConfigKey: 'customerComplaintHandlingList', // Key in the processingConfig object
    resetPath: 'supportingDocument.customerComplaintsHandling',
    resetValue: { customerComplaintsManagement: [], comment: '' },
    validationRef: 'customerComplaintsHandlingRules',
    // Corrected success message
    successMessageKey: 'Your request to save Customer Complaints Handling Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Customer Complaints Handling?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Consumer Credit Program
  saveConsumerCreditProgram: {
    label: DUE_DILIGENCE_ENUMS.CUSTOMER_CREDIT_PROGRAMS,
    // Map source fields to expected payload keys (assuming lowercase + Urls)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.supportingDocument
      customerCreditProgramsUrls: sourceDoc.consumerCreditProgram?.copiesConsumerCredit, // Map copiesConsumerCredit to customerCreditProgramsUrls
      comment: sourceDoc.consumerCreditProgram?.comment,
    }),
    listProperty: 'consumerCreditList',
    processingConfigKey: 'consumerCreditList', // Key in the processingConfig object
    resetPath: 'supportingDocument.consumerCreditProgram',
    resetValue: { copiesConsumerCredit: [], comment: '' },
    validationRef: 'consumerCreditRules',
    successMessageKey: 'Your request to save Consumer Credit Program was successful',
    confirmMessage: 'Are you sure you want to Save this Consumer Credit Program?',
    updateType: 'single', // Standard single item update
  },

  // Configuration for saving Consumer Loan Pricing
  saveConsumerLoanPricing: {
    label: DUE_DILIGENCE_ENUMS.CONSUMER_LOAN_PRICING,
    // Map source fields to expected payload keys (assuming lowercase + Url)
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.supportingDocument
      consumerLoanPricingUrl: sourceDoc.consumerLoanPricing?.loanPricingStrategy, // Map loanPricingStrategy to consumerLoanPricingUrl
      comment: sourceDoc.consumerLoanPricing?.comment,
    }),
    listProperty: 'consumerLoanPricingList',
    processingConfigKey: 'consumerLoanPricingList', // Key in the processingConfig object
    resetPath: 'supportingDocument.consumerLoanPricing',
    resetValue: { loanPricingStrategy: [], comment: '' },
    validationRef: 'consumerLoanPricingRules',
    // Corrected success message
    successMessageKey: 'Your request to save Consumer Loan Pricing was successful',
    // Corrected confirmation message
    confirmMessage: 'Are you sure you want to Save this Consumer Loan Pricing?',
    updateType: 'single', // Standard single item update
  },

  saveTaxDeductionRemittances: {
    label: DUE_DILIGENCE_ENUMS.TAX_AND_DEDUCTION_REMITTANCES,
    payloadValue: sourceDoc => ({
      taxRemittanceUrl: sourceDoc.taxDeductionRemittances?.taxRemittance,
      pensionNHFRemittanceUrl: sourceDoc.taxDeductionRemittances?.pensionNHFRemittance,
      otherDeductionRemittancesUrl: sourceDoc.taxDeductionRemittances?.otherDeductionRemittances,
      comment: sourceDoc.taxDeductionRemittances?.comment,
    }),
    listProperty: 'taxDeductionList',
    processingConfigKey: 'taxDeductionList', // Key in the processingConfig object
    resetPath: 'supportingDocument.taxDeductionRemittances', // Path in dueDiligence object
    resetValue: {
      taxRemittance: [], pensionNHFRemittance: [], otherDeductionRemittances: [], comment: '',
    },
    validationRef: 'taxDeductionRemittancesRules',
    // Corrected success message key
    successMessageKey: 'Your request to save Tax Deduction Remittances was successful',
    confirmMessage: 'Are you sure you want to Save this Tax Deduction Remittances?',
  },

  // Configuration for saving Rating Agency Reports
  saveRatingAgencyReports: {
    label: DUE_DILIGENCE_ENUMS.RATING_AGENCY_REPORT,
    // Corrected payloadValue to pull from ratingAgencyReports and use lowercase key
    payloadValue: sourceDoc => ({
      ratingAgencyReportUrl: sourceDoc.ratingAgencyReports?.ratingAgencyReport,
      comment: sourceDoc.ratingAgencyReports?.comment,
    }),
    listProperty: 'ratingAgencyReportsList',
    processingConfigKey: 'ratingAgencyReportsList',
    resetPath: 'supportingDocument.ratingAgencyReports',
    resetValue: { ratingAgencyReport: [], comment: '' },
    validationRef: 'ratingAgencyReportsRules',
    successMessageKey: 'Your request to save Rating Agency Reports was successful',
    confirmMessage: 'Are you sure you want to Save this Rating Agency Reports?',
  },

  // Configuration for saving External Board Assessment
  saveExternalBoardAssessment: {
    // Corrected label
    label: DUE_DILIGENCE_ENUMS.EXTERNAL_BOARD_ASSESSMENT,
    payloadValue: sourceDoc => ({
      // Corrected payload key casing to lowercase
      externalBoardAssessmentUrl: sourceDoc.externalBoardAssessment?.recentExternalBoard,
      comment: sourceDoc.externalBoardAssessment?.comment,
    }),
    listProperty: 'externalBoardAssessmentList',
    processingConfigKey: 'externalBoardAssessmentList',
    resetPath: 'supportingDocument.externalBoardAssessment',
    resetValue: { recentExternalBoard: [], comment: '' },
    validationRef: 'externalBoardAssessmentRules', // Corrected validation ref
    successMessageKey: 'Your request to save External Board Assessment was successful',
    confirmMessage: 'Are you sure you want to Save this External Board Assessment?',
  },

  // Configuration for saving IT System Agreement
  saveITSystemAgreement: {
    label: DUE_DILIGENCE_ENUMS.IT_SYSTEM_AGREEMENTS,
    payloadValue: sourceDoc => ({
      // Corrected payload key based on list update mapping
      itSystemAgreementsUrl: sourceDoc.itSystemAgreements?.signedAgreement,
      comment: sourceDoc.itSystemAgreements?.comment,
    }),
    listProperty: 'itSystemAgreementsList',
    processingConfigKey: 'itSystemAgreementsList', // Ensure mapping exists in processingConfig
    resetPath: 'supportingDocument.itSystemAgreements',
    resetValue: { signedAgreement: [], comment: '' },
    validationRef: 'itSystemAgreementsRules',
    successMessageKey: 'Your request to save IT System Agreement was successful',
    confirmMessage: 'Are you sure you want to Save this IT System Agreement?',
  },

  // Configuration for saving Regulatory Compliance
  saveRegulatoryCompliance: {
    label: DUE_DILIGENCE_ENUMS.REGULATORY_COMPLIANCE,
    payloadValue: sourceDoc => ({ // Use sourceDoc as the base (will be compulsoryDocument)
      regulatoryReturnsRenditionUrl: sourceDoc.regulatoryCompliance?.regulatoryReturnsRenditionUrl,
      comment: sourceDoc.regulatoryCompliance?.comment,
    }),
    listProperty: 'regulatoryComplianceList',
    processingConfigKey: 'regulatoryComplianceList', // Ensure mapping exists in processingConfig
    resetPath: 'compulsoryDocument.regulatoryCompliance', // Full path in dueDiligence
    resetValue: { regulatoryReturnsRenditionUrl: [], comment: '' },
    validationRef: 'regulatoryComplianceRules',
    successMessageKey: 'Your request to save Regulatory Compliance Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Regulatory Compliance ?',
  },

  // Configuration for saving Regulatory Examination Reports
  saveRegulatoryExaminationReports: {
    label: DUE_DILIGENCE_ENUMS.REGULATORY_EXAMINATION_REPORTS,
    payloadValue: sourceDoc => ({ // Use sourceDoc as the base (will be compulsoryDocument)
      cbnExaminationReportsUrl: sourceDoc.regulatoryExaminationReports?.cBNExaminationReportsUrl,
      ndicExaminationReportUrl: sourceDoc.regulatoryExaminationReports?.nDICExaminationReportUrl,
      managementResponseToExaminationReportUrl: sourceDoc.regulatoryExaminationReports?.managementResponseToExaminationReportUrl,
      managementResponseToNDICExaminationReportsUrl: sourceDoc.regulatoryExaminationReports?.managementResponseToNDICExaminationReportsUrl,
      comment: sourceDoc.regulatoryExaminationReports?.comment,
    }),
    listProperty: 'regulatoryExaminationReportsList',
    processingConfigKey: 'regulatoryExaminationReportsList', // Ensure mapping exists in processingConfig
    resetPath: 'compulsoryDocument.regulatoryExaminationReports', // Full path in dueDiligence
    resetValue: {
      cbnExaminationReportsUrl: [],
      ndicExaminationReportUrl: [],
      managementResponseToExaminationReportUrl: [],
      managementResponseToNDICExaminationReportsUrl: [],
      comment: '',
    },
    validationRef: 'regulatoryExaminationReportsRules',
    successMessageKey: 'Your request to save Regulatory Examination Reports Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Regulatory Examination Reports ?',
  },

  saveBoardManagementInfo: {
    label: DUE_DILIGENCE_ENUMS.BOARD_AND_MANAGEMENT_INFORMATION,
    // payloadValue function creates the specific payload structure for board management
    payloadValue: sourceDoc => ({ // sourceDoc will be dueDiligence.compulsoryDocument
      board: [{ // API expects an array containing the member being saved/updated
        designation: sourceDoc.boardManagement?.designation,
        lastName: sourceDoc.boardManagement?.lastName, // Mapping lastName to name for payload
        firstName: sourceDoc.boardManagement?.firstName, // Mapping firstName to name for payload
        middleName: sourceDoc.boardManagement?.middleName, // Mapping middleName to name for payload
        resumeURl: sourceDoc.boardManagement?.cvUpload, // Mapping cvUpload to resumeURl for payload
        dateAppointed: formatDateToISO(sourceDoc.boardManagement?.yearAppointed), // Mapping yearAppointed to dateAppointed for payload
        cbnApprovalUrl: sourceDoc.boardManagement?.cbnApprovalEvidence, // Mapping cbnApprovalEvidence to cbnApprovalUrl for payload
      }],
      comment: sourceDoc.boardManagement?.comment,
    }),
    listProperty: 'boardManagementList',
    // Use the key for board management list from processingConfig
    processingConfigKey: 'boardManagementList',
    resetPath: 'compulsoryDocument.boardManagement', // Path in dueDiligence object
    resetValue: {
      designation: '', lastName: '', firstName: '', middleName: '', cvUpload: [], yearAppointed: '', cbnApprovalEvidence: [], comment: '',
    },
    validationRef: 'boardManagementRules',
    successMessageKey: 'Your request to save Board and Management Information was successful',
    confirmMessage: 'Are you sure you want to Save this Board and Management Information?',
    // Add a property to indicate this save updates a collection
    updateType: 'collection',
  },

  // Configuration for saving Internal Risk Monitoring
  saveInternalRiskMonitoring: {
    label: DUE_DILIGENCE_ENUMS.INTERNAL_RISK_MONITORING,
    payloadValue: sourceDoc => ({ // Use sourceDoc as the base (will be compulsoryDocument)
      internalRiskMonitoringUrl: sourceDoc.internalRiskMonitoring?.InternalRiskMonitoringUrl,
      comment: sourceDoc.internalRiskMonitoring?.comment,
    }),
    listProperty: 'internalRiskMonitoringList',
    processingConfigKey: 'internalRiskMonitoringList', // Ensure mapping exists in processingConfig
    resetPath: 'supportingDocument.internalRiskMonitoring', // Full path in dueDiligence
    resetValue: { ratingAgencyReport: [], comment: '' },
    validationRef: 'internalRiskMonitoringRules',
    successMessageKey: 'Your request to save Internal Risk Monitoring Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Internal Risk Monitoring ?',
  },

  // Configuration for saving Environment And Social Risk
  saveEnvironmentAndSocialRisk: {
    label: DUE_DILIGENCE_ENUMS.ENVIRONMENTAL_AND_SOCIAL_RISK,
    payloadValue: sourceDoc => ({ // Use sourceDoc as the base (will be compulsoryDocument)
      environmentalAndSocialRiskManagementPoliciesUrl: sourceDoc.environmentAndSocialRisk?.environmentalAndSocialRiskManagementPolicies,
      relevantPoliciesFrameworkUrl: sourceDoc.environmentAndSocialRisk?.relevantPoliciesFramework,
      implementationEvidenceUrl: sourceDoc.environmentAndSocialRisk?.implementationEvidence,
      comment: sourceDoc.environmentAndSocialRisk?.comment,

    }),
    listProperty: 'environmentAndSocialRiskList',
    processingConfigKey: 'environmentAndSocialRiskList',
    resetPath: 'supportingDocument.environmentAndSocialRisk',
    resetValue: { ratingAgencyReport: [], comment: '' },
    validationRef: 'environmentAndSocialRiskRules',
    successMessageKey: 'Your request to save Environment And Social Risk Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Environment And Social Risk ?',
  },

  // Configuration for saving Advanced Risk Analysis
  saveAdvancedRiskAnalysis: {
    label: DUE_DILIGENCE_ENUMS.ADVANCED_RISK_ANALYSIS,
    payloadValue: sourceDoc => ({
      stressTestReportsUrl: sourceDoc.advancedRiskAnalysis?.stressTestReports,
      marketSensitivityAnalysisReportsUrl: sourceDoc.advancedRiskAnalysis?.marketSensitivityAnalysisReports,
      liquidityContingencyFundingPlanUrl: sourceDoc.advancedRiskAnalysis?.liquidityContingencyFundingPlan,
      businessContinuityAndDisasterRecoveryPlanUrl: sourceDoc.advancedRiskAnalysis?.businessContinuityAndDisasterRecoveryPlan,
      comment: sourceDoc.advancedRiskAnalysis?.comment,
    }),
    listProperty: 'advancedRiskAnalysisList',
    processingConfigKey: 'advancedRiskAnalysisList', // Ensure mapping exists in processingConfig
    resetPath: 'supportingDocument.advancedRiskAnalysis', // Full path in dueDiligence
    resetValue: {
      stressTestReports: [],
      marketSensitivityAnalysisReports: [],
      liquidityContingencyFundingPlan: [],
      businessContinuityAndDisasterRecoveryPlan: [],
      comment: '',
    },
    validationRef: 'advancedRiskAnalysisRules',
    successMessageKey: 'Your request to save Advanced Risk Analysis Documents was successful',
    confirmMessage: 'Are you sure you want to Save this Advanced Risk Analysis ?',
  },
  // ... add configurations for other save methods ...
}

export const documentPathMap = {
// Legal Registration Documents
  [DUE_DILIGENCE_UPLOAD_TYPES.CAC_REGISTRATION]: 'compulsoryDocument.legalRegDocuments.cacRegistration',
  [DUE_DILIGENCE_UPLOAD_TYPES.ARTICLE_OF_ASSOCIATION]: 'compulsoryDocument.legalRegDocuments.articleOfAssociation',
  [DUE_DILIGENCE_UPLOAD_TYPES.OPERATING_LICENSE]: 'compulsoryDocument.legalRegDocuments.operatingLicense',

  // Board & Management
  [DUE_DILIGENCE_UPLOAD_TYPES.CV_UPLOAD]: 'compulsoryDocument.boardManagement.cvUpload',
  [DUE_DILIGENCE_UPLOAD_TYPES.CBN_APPROVAL_EVIDENCE]: 'compulsoryDocument.boardManagement.cbnApprovalEvidence',

  // Leadership & Governance
  [DUE_DILIGENCE_UPLOAD_TYPES.BANK_ORGANISATION_STRUCTURE]: 'compulsoryDocument.leadershipGovernance.bankOrganisationStructure',
  [DUE_DILIGENCE_UPLOAD_TYPES.BANK_ORGANISATION_CHART]: 'compulsoryDocument.leadershipGovernance.bankOrganisationChart',

  // Financial Statements
  [DUE_DILIGENCE_UPLOAD_TYPES.AUDITED_FINANCIAL_STATEMENT_1]: 'compulsoryDocument.financialStatements.auditedFinancialStatement1',
  [DUE_DILIGENCE_UPLOAD_TYPES.AUDITED_FINANCIAL_STATEMENT_2]: 'compulsoryDocument.financialStatements.auditedFinancialStatement2',
  [DUE_DILIGENCE_UPLOAD_TYPES.AUDITED_FINANCIAL_STATEMENT_3]: 'compulsoryDocument.financialStatements.auditedFinancialStatement3',
  [DUE_DILIGENCE_UPLOAD_TYPES.LASTEST_FINANCIAL_PERFORMANCE]: 'compulsoryDocument.recentFinancialPerformance.latestFinancialPerformance',

  // Risk Management
  [DUE_DILIGENCE_UPLOAD_TYPES.RISK_MANAGEMENT_FRAMEWORK]: 'compulsoryDocument.riskManagementFramework.riskManagementFrameworkUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.CREDIT_RISK_MANAGEMENT]: 'compulsoryDocument.creditRiskManagement.creditRiskStrategyAndAnnualPortfolioPlan',
  [DUE_DILIGENCE_UPLOAD_TYPES.RISK_MANAGEMENT_POLICIES]: 'compulsoryDocument.riskManagementFramework.policiesUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.RISK_MANAGEMENT_LIMITS]: 'compulsoryDocument.riskManagementFramework.limitsUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.RISK_MANAGEMENT_MANUAL]: 'compulsoryDocument.riskManagementFramework.manualUrl',

  // Loan Portfolio
  [DUE_DILIGENCE_UPLOAD_TYPES.CREDIT_PORTFOLIO_REPORT]: 'compulsoryDocument.loanPortfolioDetails.creditPortfolioReport',

  // AML/CFT Compliance
  [DUE_DILIGENCE_UPLOAD_TYPES.ANTI_MONEY_LAUNDRY]: 'compulsoryDocument.aMLCFTCompliance.antiMoneyLaundryUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.COUNTER_TERRORIST_FINANCING]: 'compulsoryDocument.aMLCFTCompliance.counterTerroristFinancingPoliciesUrl',

  // Regulatory Compliance
  [DUE_DILIGENCE_UPLOAD_TYPES.REGULATORY_RETURNS_RENDITION]: 'compulsoryDocument.regulatoryCompliance.regulatoryReturnsRenditionUrl',

  // Examination Reports
  [DUE_DILIGENCE_UPLOAD_TYPES.CBN_EXAMINATION_REPORTS]: 'compulsoryDocument.regulatoryExaminationReports.cBNExaminationReportsUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.NDIC_EXAMINATION_REPORTS]: 'compulsoryDocument.regulatoryExaminationReports.nDICExaminationReportUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.MANAGEMENT_RESPONSE_TO_EXAMINATION_REPORTS]: 'compulsoryDocument.regulatoryExaminationReports.managementResponseToExaminationReportUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.MANAGEMENT_RESPONSE_TO_NDIC_EXAMINATION_REPORTS]: 'compulsoryDocument.regulatoryExaminationReports.managementResponseToNDICExaminationReportsUrl',

  // Risk & Audit Structure
  [DUE_DILIGENCE_UPLOAD_TYPES.DEPARTMENT_STRUCTURE_ORGANOGRAM]: 'compulsoryDocument.riskAndAuditStructure.organogramUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.RISK_MANAGEMENT_UNIT_STAFF_DETAILS]: 'compulsoryDocument.riskAndAuditStructure.riskManagementUnitStaffDetails.documentUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.INTERNAL_AUDIT_FUNCTION_STAFF_DETAILS]: 'compulsoryDocument.riskAndAuditStructure.internalAuditFunctionStaffDetails.documentUrl',

  // Risk Monitoring
  [DUE_DILIGENCE_UPLOAD_TYPES.RISK_MANAGEMENT_REPORTS_BOARD]: 'compulsoryDocument.ongoingRiskMonitoring.riskManagementReportsToBoardUrl',

  // Internal Audit
  [DUE_DILIGENCE_UPLOAD_TYPES.INTERNAL_AUDIT_REPORTS_LAST_YEAR]: 'compulsoryDocument.internalAuditFindings.internalAuditsReportUrlLastYear',
  [DUE_DILIGENCE_UPLOAD_TYPES.INTERNAL_AUDIT_REPORTS_LAST_TWO_YEARS]: 'compulsoryDocument.internalAuditFindings.internalAuditsReportUrlTwoYearsAgo',
  [DUE_DILIGENCE_UPLOAD_TYPES.INTERNAL_AUDIT_REPORTS_LAST_THREE_YEARS]: 'compulsoryDocument.internalAuditFindings.internalAuditsReportUrlThreeYearsAgo',

  // Corporate Governance
  [DUE_DILIGENCE_UPLOAD_TYPES.CORPRATE_GOVERNANCE_REPORT]: 'compulsoryDocument.corporateGovernance.corporateGovernanceUrl',

  // Collateral Management
  [DUE_DILIGENCE_UPLOAD_TYPES.COLLATERAL_VALUATION]: 'compulsoryDocument.collateralManagement.collateralValuationUrl',
  [DUE_DILIGENCE_UPLOAD_TYPES.NATIONAL_COLLATERAL_REGISTER]: 'compulsoryDocument.collateralManagement.nationalCollateralRegistryUrl',

  // Credit Bureau Agreement
  [DUE_DILIGENCE_UPLOAD_TYPES.EVIDENCE_OF_AGREEMENT]: 'compulsoryDocument.creditBureauAgreement.evidenceOfAgreement',

  // Supporting Documents
  [DUE_DILIGENCE_UPLOAD_TYPES.CUSTOMER_COMPLAINTS_MANAGEMENT]: 'supportingDocument.customerComplaintsHandling.customerComplaintsManagement',
  [DUE_DILIGENCE_UPLOAD_TYPES.COPIES_CONSUMER_CREDIT]: 'supportingDocument.consumerCreditProgram.copiesConsumerCredit',
  [DUE_DILIGENCE_UPLOAD_TYPES.LOAN_PRICING_STRATEGY]: 'supportingDocument.consumerLoanPricing.loanPricingStrategy',
  // [DUE_DILIGENCE_UPLOAD_TYPES.CONSUMER_LOAN_PRICING]: 'compulsoryDocument.legalRegDocuments.operatingLicense',
  [DUE_DILIGENCE_UPLOAD_TYPES.RECENT_EXTERNAL_BOARD]: 'supportingDocument.externalBoardAssessment.recentExternalBoard',
  [DUE_DILIGENCE_UPLOAD_TYPES.SIGNED_AGREEMENT]: 'supportingDocument.itSystemAgreements.signedAgreement',

  // Tax & Remittances
  [DUE_DILIGENCE_UPLOAD_TYPES.EVIDENCE_OF_TAX]: 'supportingDocument.taxDeductionRemittances.taxRemittance',
  [DUE_DILIGENCE_UPLOAD_TYPES.EVIDENCE_OF_PENSION]: 'supportingDocument.taxDeductionRemittances.pensionNHFRemittance',
  [DUE_DILIGENCE_UPLOAD_TYPES.EVIDENCE_OF_OTHER_REMITTANCES]: 'supportingDocument.taxDeductionRemittances.otherDeductionRemittances',

  // Rating & Risk
  [DUE_DILIGENCE_UPLOAD_TYPES.RATING_AGENCY_REPORT]: 'supportingDocument.ratingAgencyReports.ratingAgencyReport',
  [DUE_DILIGENCE_UPLOAD_TYPES.INTERNAL_RISK_MONITORING]: 'supportingDocument.internalRiskMonitoring.riskRegisters',

  // Environmental & Social Risk
  [DUE_DILIGENCE_UPLOAD_TYPES.ENVIRONMENTAL_AND_SOCIAL_RISK]: 'supportingDocument.environmentAndSocialRisk.environmentalAndSocialRiskManagementPolicies',
  [DUE_DILIGENCE_UPLOAD_TYPES.RELEVANT_POLICIES_FRAMEWORK]: 'supportingDocument.environmentAndSocialRisk.relevantPoliciesFramework',
  [DUE_DILIGENCE_UPLOAD_TYPES.IMPLEMENTATION_EVIDENCE]: 'supportingDocument.environmentAndSocialRisk.implementationEvidence',

  // Advanced Risk Analysis
  [DUE_DILIGENCE_UPLOAD_TYPES.STRESS_TEST_REPORTS]: 'supportingDocument.advancedRiskAnalysis.stressTestReports',
  [DUE_DILIGENCE_UPLOAD_TYPES.MARKET_SENSITIVITY_ANALYSIS_REPORTS]: 'supportingDocument.advancedRiskAnalysis.marketSensitivityAnalysisReports',
  [DUE_DILIGENCE_UPLOAD_TYPES.LIQUIDITY_CONTINGENCY_FUNDING_PLAN]: 'supportingDocument.advancedRiskAnalysis.liquidityContingencyFundingPlan',
  [DUE_DILIGENCE_UPLOAD_TYPES.BUSINESS_CONTINUITY_AND_DISASTER_RECOVERY_PLAN]: 'supportingDocument.advancedRiskAnalysis.businessContinuityAndDisasterRecoveryPlan',
  [DUE_DILIGENCE_UPLOAD_TYPES.INTERNAL_RISK_MONITORING]: 'supportingDocument.internalRiskMonitoring.riskRegisters',
}

export const PROCESS_FUNCTIONS = {
  SETUP_CREDIT_LIMIT: 'SETUP CREDIT LIMIT',
  SUBMIT_DUE_DILIGENCE: 'SUBMIT DUE DILIGENCE',
  ADD_PFI_ONBOARDING: 'ADD PFI ONBOARDING',
  SUBMIT_DIRECTORS_KYC: 'SUBMIT DIRECTORS KYC',
  // Add more process functions as you identify them
}
